import { gameMainDrawer } from './gameMainDrawer';
import { animationService } from '../../services/animationService';

import {
  frameNames,
  containerNames,
  WEB_BET_CONTAINER_START_POSITION_X,
  MOBILE_BET_CONTAINER_START_POSITION_X,
  PG_COIN,
} from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import {
  BET_BAR_MARGIN_WEB,
  BET_BAR_MARGIN_MOBILE,
  WEB_LAST_WIN_TEXT_MARGIN,
  MOBILE_LAST_WIN_TEXT_MARGIN,
} from '../../core/constants';

import { isMobile } from '../../helpers/isMobile';
import { setContainersPosition } from '../../helpers';
import { betButtonStates } from '../../helpers/betButtonStates';

import { gameStore } from '../../store/gameStore';
import { betBarStore } from '../../store/betBarStore';
import { winBarStore } from '../../store/winBarStore';
import { isoStandard } from '../../helpers/isoStandard';
import { userInfoStore } from '../../store/userInfoStore';
import { betButtonContainerXPositionHandler } from '../../helpers/betButtonContainerXPositionHandler';
import { spinBarStore } from '../../store/spinBarStore';

let isBetSlideButtonActive = true;
export class BetBarDrawer {
  constructor() {
    this.animations = {};
    this.isDraggingEnd = true;
    this.betAmountButtons = {};
    this.betAmountButtonsWidth = null;
    this.arrowButtonsIsClicked = false;
    this.webBetContainerEndPositionX = null;
    this.mobileBetContainerEndPositionX = null;
    this.betAmountButtonsWidthWithMargin = null;
    this.BetBarContainer = PixiBase.createContainer(containerNames.BetBarContainer);
    this.betButtonContainer = PixiBase.createContainer(containerNames.BetButtonContainer);
    this.betBarArrowsContainer = PixiBase.createContainer(containerNames.BetBarArrowsContainer);
    this.winAndLastWinContainer = PixiBase.createContainer(containerNames.WinAndLastWinContainer);
  }

  createGraphicsForSlider() {
    const graphics = PixiBase.createGraphics();
    this.graphics = graphics;
    this.graphics.visible = false;
    graphics.beginFill(0xff0000);
    graphics.beginFill('red');
    graphics.alpha = 0;
    graphics.drawRect(-80, -800, 1950, 1000);
    graphics.endFill();
    PixiBase.registerPointerMove(graphics, this.onHandleDragMove.bind(this));
    this.BetBarContainer.addChild(this.graphics);
  }

  handleProgressMove(e) {
    this.betButtonContainer.x = e.data.global.x - this.touchStartX;
  }

  onHandleDragMove(event) {
    if (this.isDragging) {
      if (Math.abs(event.data.global.x - this.dragX) > this.betAmountButtonsWidth / 4)
        this.isDraggingEnd = false;
      PixiBase.setupButtonMode(this.graphics, { interactive: true, buttonMode: true });
      this.handleProgressMove(event);
    }
  }

  setupSliderAnimation() {
    PixiBase.setupButtonMode(this.betButtonContainer, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.betButtonContainer, (e) => {
      this.graphics.visible = true;
      this.touchStartX = e.data.global.x - this.betButtonContainer.x;
      this.dragX = e.data.global.x;
      PixiBase.setupButtonMode(this.graphics, { interactive: true, buttonMode: true });
      this.isDragging = true;
    });
    PixiBase.registerPointerup(this.betButtonContainer, this.handleDragEnd.bind(this));
    PixiBase.registerPointerUpOutside(this.betButtonContainer, this.handleDragEnd.bind(this));
  }

  handleSliderFinalPosition() {
    const minXPosition = isMobile()
      ? this.mobileBetContainerEndPositionX
      : this.webBetContainerEndPositionX;
    const maxXPosition = isMobile()
      ? MOBILE_BET_CONTAINER_START_POSITION_X
      : WEB_BET_CONTAINER_START_POSITION_X;
    if (this.betButtonContainer.x < minXPosition) {
      PixiBase.changeFrame(this.betButtonArrowRight, frameNames.BetButtonsRightArrowDisabled);
      PixiBase.setupButtonMode(this.betButtonArrowRight, {
        interactive: false,
        buttonMode: false,
      });
      animationService.animateWithGsap({
        container: this.betButtonContainer,
        x: minXPosition,
        onComplete: () => {
          this.setArrowRightButtonDisabled();
          this.setActiveArrowLeftButton();
        },
        duration: 0.3,
      });
    } else if (this.betButtonContainer.x > maxXPosition) {
      PixiBase.changeFrame(this.betButtonArrowLeft, frameNames.BetButtonsLeftArrowDisabled);
      PixiBase.setupButtonMode(this.betButtonArrowLeft, {
        interactive: false,
        buttonMode: false,
      });
      animationService.animateWithGsap({
        container: this.betButtonContainer,
        x: maxXPosition,
        onComplete: () => {
          this.setActiveArrowRightButton();
          this.setArrowLeftButtonDisabled();
        },
        duration: 0.3,
      });
    } else {
      const buttonWidthWithMargin =
        gameMainDrawer.betBar.betAmountButtonsWidth +
        (isMobile() ? BET_BAR_MARGIN_MOBILE : BET_BAR_MARGIN_WEB);
      PixiBase.setupButtonMode(this.betButtonArrowRight, {
        interactive: true,
        buttonMode: true,
      });
      PixiBase.setupButtonMode(this.betButtonArrowLeft, {
        interactive: true,
        buttonMode: true,
      });
      PixiBase.changeFrame(this.betButtonArrowLeft, frameNames.BetButtonsLeftArrow);
      PixiBase.changeFrame(this.betButtonArrowRight, frameNames.BetButtonsRightArrow);

      const graphicsWidth = buttonWidthWithMargin * 4;

      let difference =
        this.betButtonContainer.x > 0
          ? Math.abs(
              (isMobile()
                ? MOBILE_BET_CONTAINER_START_POSITION_X
                : WEB_BET_CONTAINER_START_POSITION_X) - this.betButtonContainer.x
            ) % buttonWidthWithMargin
          : (Math.abs(this.betButtonContainer.x) +
              (isMobile()
                ? MOBILE_BET_CONTAINER_START_POSITION_X
                : WEB_BET_CONTAINER_START_POSITION_X) +
              graphicsWidth) %
            buttonWidthWithMargin;

      difference =
        difference > buttonWidthWithMargin / 2 ? difference - buttonWidthWithMargin : difference;
      animationService.animateWithGsap({
        container: this.betButtonContainer,
        x: this.betButtonContainer.x + (this.betButtonContainer.x > 87 ? -difference : difference),
        onComplete: () => {
          this.setActiveStateArrowButtons();
        },
        duration: 0.3,
      });
    }
  }

  handleDragEnd(e) {
    e.stopPropagation();
    this.isDragging = false;
    this.isDraggingEnd = true;
    this.graphics.visible = false;
    PixiBase.setupButtonMode(this.graphics, { interactive: false, buttonMode: false });
    this.handleSliderFinalPosition();
  }

  updateQuickBetsState({ alpha = 0.5, isInteractive = false } = {}) {
    Object.keys(this.betAmountButtons).forEach((key) => {
      if (+key !== +betBarStore.selectedAmount) {
        this.betAmountButtons[key].alpha = alpha;
        this.betAmountButtons[key].interactive = isInteractive;
      }
    });
  }

  updateBetBarButtonsAmountState(amount) {
    Object.keys(this.betAmountButtons).forEach((el) => {
      if (+el === +amount) {
        PixiBase.changeFrame(this.betAmountButtons[el], frameNames.SelectedQuickBetState);
      } else {
        PixiBase.changeFrame(this.betAmountButtons[el], frameNames.NormalBetButtonState);
      }
    });
  }

  updateQuickBets() {
    this.betButtonContainer.children = [];
    this.setupNormalModeBetButton();
  }

  setupNormalModeBetButton() {
    const pGCoin = !!(!gameStore.tournamentInfoInitial?.freeBetCount && spinBarStore.tournamentId);
    const { currencySymbol } = userInfoStore;
    const betButtonsMaskGraphics = PixiBase.createGraphics();
    this.betButtonMaskGraphics = PixiBase.setMaskGraphicProperties(
      betButtonsMaskGraphics,
      isMobile() ? [28, 590, 484, 160] : [440, 680, 580, 70]
    );
    PixiBase.setMaskGraphicToContainer(this.betButtonContainer, this.betButtonMaskGraphics);
    this.setupSliderAnimation();
    const { quickBetArr } = betBarStore;
    quickBetArr.forEach((item, index) => {
      const betButtonWrapper = PixiBase.createContainer('betButtonWrapper');
      this.betButtonWrapper = betButtonWrapper;
      const normalModeBetButton = PixiBase.createSprite(this.spriteSheet.normalBetButtonState);
      index === betBarStore.selectedBetAmountIndex &&
        PixiBase.changeFrame(normalModeBetButton, frameNames.SelectedQuickBetState);
      this.betAmountButtonsWidth = normalModeBetButton.width;
      this.betAmountButtonsWidthWithMargin =
        this.betAmountButtonsWidth + (isMobile() ? BET_BAR_MARGIN_MOBILE : BET_BAR_MARGIN_WEB);
      this.betAmountButtons[item] = normalModeBetButton;
      normalModeBetButton.amountValue = item;
      betButtonWrapper.amountValue = item;
      normalModeBetButton.id = index;
      betBarStore.setBetButtonSprites(normalModeBetButton);
      this.currencyTexture = PixiBase.createText(pGCoin ? PG_COIN : currencySymbol, {
        fontSize: 15,
        fill: '#FFFFFF',
        align: 'center',
        fontWeight: pGCoin ? 300 : 600,
        fontFamily: 'Roboto',
      });
      this.amount = PixiBase.createText(isoStandard(item), {
        fontSize: 23,
        fill: '#FFD880',
        align: 'center',
        fontWeight: 600,
        fontFamily: 'Roboto',
      });
      const { x, y, anchor } = this.config.BetBarContainer.normalBetButtonsConfig;
      const { x: currencyX, y: currencyY } = this.config.BetBarContainer.currencyConfig;
      const { x: amountX, y: amountY } = this.config.BetBarContainer.betButtonsAmountConfig;
      const amountXFinalPosition = isMobile() ? amountX + index * 122 : amountX + index * 145;
      PixiBase.setPosition(this.amount, {
        x: Math.ceil(amountXFinalPosition),
        y: amountY,
      });
      const currencyTextureFinalPosition = isMobile()
        ? currencyX + index * 122
        : currencyX + index * 145;

      PixiBase.setPosition(this.currencyTexture, {
        x: Math.ceil(currencyTextureFinalPosition),
        y: currencyY,
      });
      const normalModeBetButtonXFinalPosition = isMobile() ? x + index * 122 : x + index * 145;
      PixiBase.setPosition(normalModeBetButton, {
        x: Math.ceil(normalModeBetButtonXFinalPosition),
        y: y,
      });
      normalModeBetButton.anchor.set(anchor);
      this.currencyTexture.anchor.set(anchor);
      this.amount.anchor.set(anchor);
      betButtonWrapper.addChild(normalModeBetButton);
      betButtonWrapper.addChild(this.amount);
      betButtonWrapper.addChild(this.currencyTexture);
      this.betButtonContainer.addChild(betButtonWrapper);
      PixiBase.setupButtonMode(betButtonWrapper, { interactive: true, buttonMode: true });
      betButtonStates(betButtonWrapper, false);
    });

    this.webBetContainerEndPositionX =
      WEB_BET_CONTAINER_START_POSITION_X -
      (quickBetArr.length - 4) * this.betAmountButtonsWidthWithMargin;
    this.mobileBetContainerEndPositionX =
      MOBILE_BET_CONTAINER_START_POSITION_X -
      (quickBetArr.length - 4) * this.betAmountButtonsWidthWithMargin;
    this.createGraphicsForSlider();
    this.BetBarContainer.addChild(this.betButtonContainer);
    betButtonContainerXPositionHandler(betBarStore.selectedBetAmountIndex);
    PixiBase.registerPointerMove(this.betButtonContainer, this.onHandleDragMove.bind(this));
  }

  setupBetButtonArrowRight() {
    this.betButtonArrowRight = PixiBase.createSprite(this.spriteSheet.betButtonsRightArrow);
    const { x, y, anchor } = this.config.BetBarContainer.betButtonArrowRightConfig;
    PixiBase.setPosition(this.betButtonArrowRight, { x: x, y: y });
    PixiBase.setupButtonMode(this.betButtonArrowRight, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.betButtonArrowRight, (e) => {
      this.arrowButtonsIsClicked = true;
      PixiBase.changeFrame(e.target, frameNames.BetButtonsRightArrowPressed);
    });
    PixiBase.registerPointerMove(this.betButtonArrowRight, (e) => {
      PixiBase.changeFrame(e.target, frameNames.BetButtonsRightArrowHovered);
    });
    PixiBase.registerPointerup(this.betButtonArrowRight, (e) => {
      if (!this.arrowButtonsIsClicked) {
        return;
      }
      this.arrowButtonsIsClicked = false;
      if (!isBetSlideButtonActive) {
        return;
      }
      PixiBase.changeFrame(e.target, frameNames.BetButtonsRightArrow);
      isBetSlideButtonActive = false;
      if (isMobile()) {
        if (this.betButtonContainer.x > this.mobileBetContainerEndPositionX) {
          animationService.slideAnimation({
            container: this.betButtonContainer,
            isLeft: false,
            onComplete: () => {
              isBetSlideButtonActive = true;
              if (this.betButtonContainer.x === this.mobileBetContainerEndPositionX) {
                this.setArrowRightButtonDisabled();
                this.setActiveArrowLeftButton();
              } else {
                this.setActiveStateArrowButtons();
              }
            },
          });
        } else {
          isBetSlideButtonActive = true;
        }
      } else if (this.betButtonContainer.x >= this.webBetContainerEndPositionX) {
        animationService.slideAnimation({
          container: this.betButtonContainer,
          isLeft: false,
          onComplete: () => {
            isBetSlideButtonActive = true;
            if (this.betButtonContainer.x === this.webBetContainerEndPositionX) {
              this.setArrowRightButtonDisabled();
            } else {
              this.setActiveStateArrowButtons();
            }
          },
        });
      } else {
        isBetSlideButtonActive = true;
      }
    });
    PixiBase.registerPointerout(this.betButtonArrowRight, (e) => {
      e.target.cursor = 'auto';
      PixiBase.changeFrame(e.target, frameNames.BetButtonsRightArrow);
    });
    this.betButtonArrowRight.anchor.set(anchor);
    this.betBarArrowsContainer.addChild(this.betButtonArrowRight);
  }

  setArrowLeftButtonDisabled() {
    PixiBase.changeFrame(this.betButtonArrowLeft, frameNames.BetButtonsLeftArrowDisabled);
    this.betButtonArrowLeft.cursor = 'auto';
    PixiBase.setupButtonMode(this.betButtonArrowLeft, { interactive: false, buttonMode: false });
  }

  setActiveArrowLeftButton() {
    PixiBase.changeFrame(this.betButtonArrowLeft, frameNames.BetButtonsLeftArrow);
    PixiBase.setupButtonMode(this.betButtonArrowLeft, { interactive: true, buttonMode: true });
  }

  setActiveArrowRightButton() {
    PixiBase.changeFrame(this.betButtonArrowRight, frameNames.BetButtonsRightArrow);
    PixiBase.setupButtonMode(this.betButtonArrowRight, { interactive: true, buttonMode: true });
  }

  setArrowRightButtonDisabled() {
    PixiBase.changeFrame(this.betButtonArrowRight, frameNames.BetButtonsRightArrowDisabled);
    this.betButtonArrowRight.cursor = 'auto';
    PixiBase.setupButtonMode(this.betButtonArrowRight, { interactive: false, buttonMode: false });
  }

  setActiveStateArrowButtons() {
    this.setActiveArrowLeftButton();
    this.setActiveArrowRightButton();
  }

  setupBetButtonArrowLeft() {
    this.betButtonArrowLeft = PixiBase.createSprite(this.spriteSheet.betButtonsLeftArrowPressed);
    const { x, y, anchor } = this.config.BetBarContainer.betButtonArrowLeftConfig;
    PixiBase.setPosition(this.betButtonArrowLeft, { x: x, y: y });
    PixiBase.setupButtonMode(this.betButtonArrowLeft, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.betButtonArrowLeft, (e) => {
      this.arrowButtonsIsClicked = true;
      PixiBase.changeFrame(e.target, frameNames.BetButtonsLeftArrowPressed);
    });
    PixiBase.registerPointerMove(this.betButtonArrowLeft, (e) => {
      PixiBase.changeFrame(e.target, frameNames.BetButtonsLeftArrowHovered);
    });
    PixiBase.registerPointerup(this.betButtonArrowLeft, (e) => {
      if (!this.arrowButtonsIsClicked) {
        return;
      }
      this.arrowButtonsIsClicked = false;
      if (!isBetSlideButtonActive) {
        return;
      }
      isBetSlideButtonActive = false;
      PixiBase.changeFrame(e.target, frameNames.BetButtonsLeftArrow);

      if (isMobile()) {
        if (this.betButtonContainer.x < MOBILE_BET_CONTAINER_START_POSITION_X) {
          animationService.slideAnimation({
            container: this.betButtonContainer,
            isLeft: true,
            onComplete: () => {
              isBetSlideButtonActive = true;
              if (this.betButtonContainer.x === MOBILE_BET_CONTAINER_START_POSITION_X) {
                this.setArrowLeftButtonDisabled();
                this.setActiveArrowRightButton();
              } else {
                this.setActiveStateArrowButtons();
              }
            },
          });
        } else {
          isBetSlideButtonActive = true;
        }
      } else if (this.betButtonContainer.x < WEB_BET_CONTAINER_START_POSITION_X) {
        animationService.slideAnimation({
          container: this.betButtonContainer,
          isLeft: true,
          onComplete: () => {
            isBetSlideButtonActive = true;
            if (this.betButtonContainer.x === WEB_BET_CONTAINER_START_POSITION_X) {
              this.setArrowLeftButtonDisabled();
              this.setActiveArrowRightButton();
            } else {
              this.setActiveStateArrowButtons();
            }
          },
        });
      } else {
        isBetSlideButtonActive = true;
      }
    });
    PixiBase.registerPointerout(this.betButtonArrowLeft, (e) => {
      e.target.cursor = 'auto';
      PixiBase.changeFrame(e.target, frameNames.BetButtonsLeftArrow);
    });
    this.betButtonArrowLeft.anchor.set(anchor);
    this.betBarArrowsContainer.addChild(this.betButtonArrowLeft);
    this.BetBarContainer.addChild(this.betBarArrowsContainer);
  }

  setupWinAndLastWinText(text = gameStore.canvasTranslationKeys.LAST_WIN) {
    this.winAndLastWinText = PixiBase.createText(`${text}:`, {
      fontSize: isMobile() ? 25 : 20,
      fill: '#FFFFFF',
      align: 'left',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });

    const { x, y } = this.config.BetBarContainer.winAndLastWinTextConfig;
    PixiBase.setPosition(this.winAndLastWinText, { x: x, y: y });
    this.winAndLastWinContainer.addChild(this.winAndLastWinText);
  }

  setupWinAndLastWinAmount() {
    this.winAndLastWinAmount = PixiBase.createText('', {
      fontSize: isMobile() ? 35 : 22,
      fill: '#FFD880',
      align: 'left',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });
    const { y } = this.config.BetBarContainer.winAndLastWinAmountConfig;
    PixiBase.setPosition(this.winAndLastWinAmount, {
      x:
        this.winAndLastWinText.width +
        (isMobile() ? MOBILE_LAST_WIN_TEXT_MARGIN : WEB_LAST_WIN_TEXT_MARGIN),
      y,
    });
    this.winAndLastWinContainer.addChild(this.winAndLastWinAmount);
    this.winAndLastWinContainer.visible = false;
    this.BetBarContainer.addChild(this.winAndLastWinContainer);
  }

  setupCurrencyCode() {
    const { currencySymbol } = userInfoStore;
    this.currencyCode = PixiBase.createText(`${currencySymbol}`, {
      fontSize: isMobile() ? 25 : 20,
      fill: '#FFFFFF',
      align: 'left',
      fontWeight: 510,
      fontFamily: 'Roboto',
    });

    this.updateCurrencyCodePosition();
    this.winAndLastWinContainer.addChild(this.currencyCode);
  }

  updateAmountPosition() {
    const amountYPosition =
      this.winAndLastWinText.y + this.winAndLastWinText.height - this.winAndLastWinAmount.height;
    PixiBase.setPosition(this.winAndLastWinAmount, {
      x:
        this.winAndLastWinText.width +
        (isMobile() ? MOBILE_LAST_WIN_TEXT_MARGIN : WEB_LAST_WIN_TEXT_MARGIN),
      y: amountYPosition - amountYPosition / 3,
    });
  }

  updateCurrencyCodePosition() {
    const pGCoin = !!(!gameStore.tournamentInfoInitial?.freeBetCount && spinBarStore.tournamentId);
    const { currencySymbol } = userInfoStore;
    this.currencyCode.text = pGCoin ? PG_COIN : currencySymbol;
    const currencyYPosition =
      this.winAndLastWinText.y + this.winAndLastWinText.height - this.currencyCode.height;
    PixiBase.setPosition(this.currencyCode, {
      x:
        this.winAndLastWinAmount.x +
        this.winAndLastWinAmount.width +
        (isMobile() ? MOBILE_LAST_WIN_TEXT_MARGIN : WEB_LAST_WIN_TEXT_MARGIN),
      y: currencyYPosition,
    });
    this.setLastWinContainerPosition();
  }

  increaseWinAndLastWinContainerPositionByFreeBet() {
    this.winAndLastWinContainer.y += isMobile() ? 0 : 14;
  }

  decreaseWinAndLastWinContainerPositionByFreeBet() {
    this.winAndLastWinContainer.y -= isMobile() ? 0 : 14;
  }

  updateLastWinAmount(winAmount) {
    this.winAndLastWinContainer.visible = true;
    this.winAndLastWinAmount.text = isoStandard(+winAmount);
    this.updateCurrencyCodePosition();
    setTimeout(() => {
      if (winBarStore.prevWinAmount && !+winAmount) {
        this.winAndLastWinAmount.text = isoStandard(+winBarStore.prevWinAmount);
        winBarStore.setWinAmount(0);
        this.updateLastWinText();
        this.updateCurrencyCodePosition();
      }
    }, 700);
  }

  updateLastWinText() {
    const text =
      winBarStore.winAmount || !winBarStore.prevWinAmount
        ? gameStore.canvasTranslationKeys.WIN
        : gameStore.canvasTranslationKeys.LAST_WIN;

    this.winAndLastWinText.text = `${text}:`;
    if (winBarStore.winAmount) {
      this.winAndLastWinText.alpha = 1;
      this.currencyCode.alpha = 1;
    } else {
      this.winAndLastWinText.alpha = 0.5;
      this.currencyCode.alpha = 0.5;
    }
    this.updateAmountPosition();
    this.updateCurrencyCodePosition();
  }

  setLastWinContainerPosition() {
    const min = isMobile() ? 0 : -90;
    const max = isMobile() ? 540 : 505;
    PixiBase.setPosition(this.winAndLastWinContainer, {
      x: min + (max - min - this.winAndLastWinContainer.width) / 2,
      y: this.winAndLastWinContainer.y,
    });
  }

  resetLastWinContainerPosition() {
    PixiBase.setPosition(
      this.winAndLastWinContainer,
      isMobile() ? { x: 268, y: 40 } : { x: 189, y: 123 }
    );
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    const {
      BetBarContainer: {
        betBarContainerConfig,
        betButtonContainerConfig,
        betBarArrowsContainerConfig,
        winAndLastWinContainerConfig,
      },
    } = this.config;
    setContainersPosition(this.BetBarContainer, betBarContainerConfig);
    setContainersPosition(this.betButtonContainer, betButtonContainerConfig);
    setContainersPosition(this.betBarArrowsContainer, betBarArrowsContainerConfig);
    setContainersPosition(this.winAndLastWinContainer, winAndLastWinContainerConfig);
    this.setupWinAndLastWinText();
    this.setupBetButtonArrowRight();
    this.setupBetButtonArrowLeft();
    this.setupWinAndLastWinAmount();
    this.setupCurrencyCode();
  }
}
